import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Shows/hides the "Add Maintenance Rule" modal's field groups (calendar
// interval, usage interval+counter, condition stream+operator+value) and
// their matching inline help text, keyed off the Trigger Type select
// (#maint_rule_trigger_type). Also disables inputs inside hidden groups so
// irrelevant values are never submitted alongside the active trigger type.
export default class extends Controller {
  static targets = ["select", "group", "help"]

  connect() {
    this.apply()
  }

  apply() {
    if (!this.hasSelectTarget) return
    const value = this.selectTarget.value

    this.groupTargets.forEach((group) => {
      const types = (group.dataset.triggerTypes || "").split(" ").filter(Boolean)
      const show = types.includes(value)
      group.classList.toggle("hidden", !show)
      group.querySelectorAll("input, select, textarea").forEach((el) => {
        el.disabled = !show
      })
    })

    this.helpTargets.forEach((help) => {
      help.classList.toggle("hidden", help.dataset.triggerType !== value)
    })
  }
}
